var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8332 17.5434V19.0001C34.8312 22.4144 33.7256 25.7367 31.6813 28.4713C29.6369 31.206 26.7634 33.2065 23.4892 34.1746C20.2149 35.1427 16.7155 35.0265 13.5127 33.8432C10.31 32.66 7.57554 30.4731 5.71719 27.6088C3.85884 24.7445 2.97617 21.3562 3.20083 17.9493C3.42548 14.5423 4.74542 11.2993 6.96378 8.70381C9.18215 6.10832 12.1801 4.29947 15.5105 3.54701C18.8409 2.79455 22.3253 3.13881 25.444 4.52844",
    stroke: "#8AFCDA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8333 6.3335L19 22.1827L14.25 17.4327",
    stroke: "#8AFCDA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessOutlined);
export default __webpack_public_path__ + "static/media/success-outlined.003551da0d0aac72108e596b523f581c.svg";
export { ForwardRef as ReactComponent };